import { render, staticRenderFns } from "./depositList.vue?vue&type=template&id=fe5ed822&scoped=true&"
import script from "./depositList.vue?vue&type=script&lang=js&"
export * from "./depositList.vue?vue&type=script&lang=js&"
import style0 from "./depositList.vue?vue&type=style&index=0&id=fe5ed822&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5ed822",
  null
  
)

export default component.exports